import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import {
  getLabelTag,
  getLabelTagInput,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import {
  dietOptions,
  entrealDietOptions,
  liquidDietOptions,
  oralDietOptions,
  otherSpecificationsOptions,
  parentalTypeOptions,
  rootFeedOptions,
} from "../../Options/dietAdviceOptions";
import { yesNoOptions } from "../../Options/commonOptions";
import dietAdviceIcon from "../../../../assets/doctorIcons/dietAdvice.svg";

const NutritionistDietAdviceSummary = ({ formData }) => {
  const constructDietAdviceSummaryItems = () => {
    const dietAdviceSummaryItems = [];
    const pushDietAdviceItem = (key, label, children) => {
      dietAdviceSummaryItems.push({ key, label, children });
    };
    const diet = formData?.diet_advice || {};
    if (
      diet?.nutritional_recommendations?.calories ||
      diet?.nutritional_recommendations?.protein ||
      diet?.nutritional_recommendations?.carbohydrates ||
      diet?.nutritional_recommendations?.sodium ||
      diet?.nutritional_recommendations?.potassium
    ) {
      pushDietAdviceItem(
        "1",
        "Nutritional Recommendations",
        <>
          {getLabelTagInput(
            "Energy",
            diet?.nutritional_recommendations?.calories,
            "K.cal/day"
          )}
          {getLabelTagInput(
            "Protein",
            diet?.nutritional_recommendations?.protein,
            "gms/day"
          )}
          {getLabelTagInput(
            "Carbohydrates",
            diet?.nutritional_recommendations?.carbohydrates,
            "gms/day"
          )}
          {getLabelTagInput(
            "Sodium",
            diet?.nutritional_recommendations?.sodium,
            "mg/day"
          )}
          {getLabelTagInput(
            "Potassium",
            diet?.nutritional_recommendations?.potassium,
            "mg/day"
          )}
        </>
      );
    }
    if (diet?.diet_details?.diet) {
      pushDietAdviceItem(
        "2",
        "Type of Diet",
        <>
          {getLabelTag(dietOptions, diet?.diet_details?.diet)}
          {getLabelTag(oralDietOptions, diet?.diet_details?.type_of_oral_diet)}
          {getLabelTag(
            liquidDietOptions,
            diet?.diet_details?.type_of_liquid_diet
          )}
          {getLabelTag(
            entrealDietOptions,
            diet?.diet_details?.type_of_feedings
          )}
          {getLabelTag(
            rootFeedOptions,
            diet?.diet_details?.root_of_enteral_feed
          )}
          {/* {getLabelTag(
            diet?.diet_details?.type_of_feedings === "continuous"
              ? continuousFeedOptions
              : intermittentFeedOptions,
            diet?.diet_details?.root_of_enteral_feed
          )} */}
          {getLabelTag(
            parentalTypeOptions,
            diet?.diet_details?.type_of_parenteral_diet
          )}
          {getLabelTagInput(
            "Central Line",
            diet?.diet_details?.parental_central_line
          )}
          {getLabelTagInput(
            "Peripheral Line",
            diet?.diet_details?.parental_peripheral_line
          )}
        </>
      );
    }
    if (
      getLabelTagsWithDescription(
        otherSpecificationsOptions,
        diet?.other_specifications
      )
    ) {
      pushDietAdviceItem(
        "3",
        "Other Specifications",
        <>
          {getLabelTagsWithDescription(
            otherSpecificationsOptions,
            diet?.other_specifications
          )}
          {getLabelTagsWithDynamicInputs(diet?.other_specifications?.others)}
        </>
      );
    }
    if (diet?.patient_family_education) {
      pushDietAdviceItem(
        "4",
        "Patient Family Education",
        getLabelTag(yesNoOptions, diet?.patient_family_education)
      );
    }
    return dietAdviceSummaryItems;
  };
  const dietAdviceSummaryItems = constructDietAdviceSummaryItems();
  return (
    <SummaryWrapper
      items={dietAdviceSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={dietAdviceIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Diet Advice
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default NutritionistDietAdviceSummary;
